import React, { Component } from "react";
import { Button } from "react-bootstrap";
import ReactTable from "react-table";
import PropTypes from "prop-types";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faEdit,
  faTrash,
  faShare,
  faListUl,
} from "@fortawesome/free-solid-svg-icons";

export default class TBLDetalheCupom extends Component {
  constructor(props) {
    super(props);
    this.state = {};

    this.columns = [
      {
        Header: "Estabelecimento",
        accessor: "estabelecimento.nome_fantasia",
        className: "center",
      },
      {
        Header: "Atividade",
        accessor: "atividade",
        className: "center",
      },
      {
        Header: "Ativações",
        accessor: "num_ativacoes",
        className: "center",
      },
      {
        Header: "Consumo",
        accessor: "consumo",
        className: "center",
      },
      {
        Header: "Disponível",
        accessor: "disponivel",
        className: "center",
      },
      {
        Header: "Recurso Total",
        accessor: "recurso_total",
        className: "center",
      },
    ];
  }

  setData = (data) => {
    let cons = 0;
    let disp = 0;
    let lim = 0;
     data.map((a) => {

        a.atividade = this.props.cupom.ativo ? "Ativo" : "Inativo";

        a.consumo = `R$${a.consumo_estabelecimento}`;
        a.disponivel = `R$${this.props.cupom.recurso - a.consumo_estabelecimento}`;

      a.recurso_total = `R$${this.props.cupom.recurso}`;
    }); 
  };

  gerenciarAcoes = (tipo, dados) => {
    if (tipo === "editar") {
      this.props.dataCallback(tipo, dados);
    } else if (tipo === "deletar") {
      this.props.dataCallback(tipo, dados);
    } else {
      return;
    }
  };

  render() {
    this.setData(this.props.data);
    return (
      <ReactTable
        data={this.props.data}
        className="-striped -highlight"
        columns={this.columns}
        resizable
        style={{ maxHeight: 572 }}
        showPagination={this.props.showPagination}
        defaultPageSize={this.props.numRows}
        previousText="Anterior"
        nextText="Próximo"
        loadingText="Carregando..."
        noDataText="Nenhum dado encontrado!"
        pageText="Página"
        ofText="de"
        rowsText="linhas"
      />
    );
  }
}

TBLDetalheCupom.propTypes = {
  data: PropTypes.array,
  showPagination: PropTypes.bool,
  numRows: PropTypes.number,
  dataCallback: PropTypes.func,
  isDespacho: PropTypes.bool,
};
